// extracted by mini-css-extract-plugin
module.exports = {"container":"_1YgPYgFbBJPH6fg_NFQH1j"};